function cov_ube4s36r4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SquareFeet.tsx";
  var hash = "da3bc9ee3b618e3a1829ed19af49eadc3454c5f2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/SquareFeet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 7,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "da3bc9ee3b618e3a1829ed19af49eadc3454c5f2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ube4s36r4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ube4s36r4();
var Icon = (cov_ube4s36r4().s[0]++, {
  name: 'square-feet',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.25 2C3.00736 2 2 3.00736 2 4.25V8.04623C2 9.97933 4.27682 11.0125 5.73163 9.73953L10.0702 5.9433C11.6337 4.57521 10.6661 2 8.58855 2H4.25ZM4.5 7.49529V4.5H7.92319L4.5 7.49529Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.75 22C20.9926 22 22 20.9926 22 19.75V15.9538C22 14.0207 19.7232 12.9875 18.2684 14.2605L13.9298 18.0567C12.3663 19.4248 13.3339 22 15.4114 22H19.75ZM19.5 16.5047V19.5H16.0768L19.5 16.5047Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22 4.25C22 3.00736 20.9926 2 19.75 2H15.4114C13.3339 2 12.3663 4.57521 13.9298 5.9433L18.2684 9.73953C19.7232 11.0125 22 9.97933 22 8.04623V4.25ZM19.5 4.5V7.49529L16.0768 4.5H19.5Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.58855 22H4.25C3.00736 22 2 20.9926 2 19.75V15.9538C2 14.0207 4.27682 12.9875 5.73163 14.2605L10.0702 18.0567C11.6337 19.4248 10.6661 22 8.58855 22ZM4.5 16.5047L4.5 19.5H7.92319L4.5 16.5047Z\" fill=\"currentColor\"/>"
});
export default Icon;